import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'bo-light-theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private lightThemeSubject = new BehaviorSubject<boolean>(this.readStored());
  public lightTheme$ = this.lightThemeSubject.asObservable();

  public get lightTheme(): boolean {
    return this.lightThemeSubject.value;
  }

  public toggle(): void {
    this.setLightTheme(!this.lightThemeSubject.value);
  }

  public setLightTheme(value: boolean): void {
    this.lightThemeSubject.next(value);
    try {
      localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
    } catch {
      // storage unavailable (private browsing, etc) — theme just won't persist
    }
  }

  private readStored(): boolean {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  }
}
